import React from 'react';
// @ts-ignore
import ErrorLogo from '../../assets/img/Error_Logo.svg';
import './general-error-page.scss';

const GeneralErrorPage = () => (
    <div className="general-error-page">
        <div className="general-error-page-header-row">
            <div className="general-error-page-icon">
                <img
                    id="general-error-page-logo"
                    src={ErrorLogo}
                    alt="Error Logo"
                />
            </div>
            <div>
                <div className="general-error-page-message-header">
                    You do not have access to this page.
                </div>
                <div className="general-error-page-error-status">
                    Error: 403 Not Authorized
                </div>
            </div>
        </div>
    </div>
);

export default GeneralErrorPage;
